// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"DialogMessage_mainContainer__QN7lf"};